import { Tooltip } from "antd";
import React, { useContext } from "react";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { default as FetchContext } from "../../../../contexts/fetch";
import UserContext from "../../../../contexts/user";
import FlowContext from "../../../../contexts/flowContext";
import SimulationContext from "../../../../contexts/simulation";
import styles from "../controls.module.css";
import { flowToConfig } from "../utils";

const WebAppPreview = () => {
  const [flowState] = useContext(FlowContext);
  const [, simulationDispatcher] = useContext(SimulationContext);
  const [userState] = useContext(UserContext);
  const [fetchState] = useContext(FetchContext);

  const handlePreviewButtonClick = function (e) {
    simulationDispatcher({
      type: "toggle-webapp-preview",
      buttonPosition: {
        x: e.clientX,
        y: e.clientY,
      },
    });
  };

  return (
    userState.currentApp === "web-app" && (
      <div
        className={styles.button_container}
        onClick={handlePreviewButtonClick}
      >
        <Tooltip placement="bottom" title={"Webb App preview"}>
          <span className={styles.icon_container}>
            <IoPhonePortraitOutline className={styles.webapp_preview_button} />
          </span>
        </Tooltip>
      </div>
    )
  );
};

export default WebAppPreview;
